import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const formbricks = defineConnector({
  identifier: "formbricks",
  name: "Formbricks",
  tagLine: "Open source survey platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://app\\.formbricks\\.com/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Formbricks instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "app.formbricks.com",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Use app.formbricks.com for Formbricks Cloud, or your self-hosted domain.",
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Formbricks, go to **Settings › API Keys** and create a new key. See the [API docs](https://formbricks.com/docs/api-reference/rest-api) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/me`,
  },
});
